<h1 class="section__heading">{{ mainTitle }}</h1>
<div class="section__title section__title--container">
  <h2>
    <dlg-icon *ngIf="titleIcon" name="{{ titleIcon }}" class="dlg-icon section__icon-{{ titleIcon }}"></dlg-icon>
    {{ subTitle }}
  </h2>
  <div class="section__title--container-extra-info" *ngIf="isShowPolicyNumber">
    POLICY NUMBER:
    <span class="policy-number" data-recording-mask>{{ policyId }}</span>
  </div>
</div>
<ng-container *ngIf="isNotification">
  <div class="section__notification-banner">
    <span>All changes will take effect from {{ policyChangeDateString }}</span>
  </div>
</ng-container>
